import {
  CategoryConfigFactory,
  DiffValue,
} from "components/search/input/DifferencePanel/common";
import { MiscParams } from "store/api/generatedApi";

export const MiscParamsConfigFactory: CategoryConfigFactory<MiscParams> = ({
  isAdmin,
  t,
}) => ({
  ...(isAdmin
    ? {
        rounded_solution: {
          title: t("integerSolution"),
          renderDiff: ({
            updatedVal,
            previousVal,
          }: {
            updatedVal: boolean;
            previousVal: boolean;
          }) => {
            return (
              <DiffValue>
                {previousVal ? t("yes") : t("no")} →{" "}
                {updatedVal ? t("yes") : t("no")}
              </DiffValue>
            );
          },
          format: (val: boolean) => (val ? t("yes") : t("no")),
        },
      }
    : {}),
});
